import React from "react";
import closeImg from "../Resources/svg/icon-close.svg";
import TableLog from "./tableLog";

const ModalLog = ({
  open,
  onCloseModal,
  items,
  CUSPP,
  setOpenModalConfirmLogQuote,
  setQuoteSelected,
}) => {
  return (
    <div className={`md-g-wapper ${open ? "md-g-open" : ""}`}>
      <div className="md-g-wapper__container">
        <img
          src={closeImg}
          alt="imgClose"
          className="md-g-wapper__container__button-close"
          onClick={() => onCloseModal()}
        />
      <div className="title">CUSPP: {CUSPP}</div>

        <TableLog
          items={items}
          CUSPP={CUSPP}
          setOpenModalConfirmLogQuote={setOpenModalConfirmLogQuote}
          setQuoteSelected={setQuoteSelected}
        />
      </div>
    </div>
  );
};

export default ModalLog;
